export const MAIN_COMMON_TEST_IDS = {
  // ─── Navbar ───
  navbar: 'main-common-navbar',
  navHomeLink: 'main-common-nav-home-link',
  navStaffLink: 'main-common-nav-staff-link',
  navUserName: 'main-common-nav-username',

  // ─── Location Permission Modal ───
  locationModal: 'main-common-location-modal',
  locationAllowButton: 'main-common-location-allow-btn',
  locationDenyButton: 'main-common-location-deny-btn',
} as const;
